/* ════════════════════════════════════════════════════════════
   YOURAYOU — Cart drawer
   Ouverture/fermeture du tiroir panier + mutations (qty, remove,
   upsell) branchées sur YOURAYOUCart. Re-render via la section
   'custom-cart-drawer' (on remplace #cd-inner).
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  window.YOURAYOU = window.YOURAYOU || {};
  if (window.YOURAYOU.CartDrawer) return;

  var drawer, scrim, bigClose, lastFocus;

  function lockBody(lock) {
    if (lock) {
      var sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = sb + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    scrim.hidden = false;
    // forcer un reflow pour que la transition s'applique
    void scrim.offsetWidth;
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    if (bigClose) bigClose.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBody(true);
    var closeBtn = drawer.querySelector('.cd-close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    if (bigClose) bigClose.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    lockBody(false);
    var sc = scrim;
    setTimeout(function () { if (sc && !sc.classList.contains('is-open')) sc.hidden = true; }, 320);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  /* Remplace le contenu interne du tiroir à partir d'une réponse
     Section Rendering API (sections['custom-cart-drawer']). */
  function renderDrawer(response) {
    if (!response || !response.sections || !response.sections['custom-cart-drawer']) return response;
    var parsed = new DOMParser().parseFromString(response.sections['custom-cart-drawer'], 'text/html');
    var fresh = parsed.querySelector('#cd-inner');
    var current = document.getElementById('cd-inner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    return response;
  }

  /* Affiche un message d'erreur discret dans le tiroir (rupture, réseau…)
     au lieu de laisser l'UI muette. */
  function showCartError(msg) {
    var el = document.getElementById('cd-error');
    if (!el) return;
    el.textContent = msg || 'Une erreur est survenue. Réessaie.';
    el.hidden = false;
    clearTimeout(showCartError._t);
    showCartError._t = setTimeout(function () { el.hidden = true; }, 4500);
  }

  function afterMutation(response) {
    if (response && response._error) {
      showCartError(response.description || response.message);
      return response;
    }
    renderDrawer(response);
    if (window.YOURAYOUCart && typeof YOURAYOUCart.updateBadge === 'function') {
      YOURAYOUCart.updateBadge(response);
    }
    return response;
  }

  /* Délégation des clics dans le tiroir */
  function onDrawerClick(e) {
    var closeEl = e.target.closest('[data-cd-close]');
    if (closeEl) { close(); return; }

    if (!window.YOURAYOUCart) return;

    var qtyBtn = e.target.closest('.cd-qty-btn');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10) || 0;
      var action = qtyBtn.getAttribute('data-action');
      var next = action === 'plus' ? qty + 1 : qty - 1;
      YOURAYOUCart.updateCart(key, next < 0 ? 0 : next).then(afterMutation).catch(function () { showCartError(); });
      return;
    }

    var rm = e.target.closest('[data-action="remove"]');
    if (rm) {
      YOURAYOUCart.removeFromCart(rm.getAttribute('data-key')).then(afterMutation).catch(function () { showCartError(); });
      return;
    }

    var up = e.target.closest('[data-action="add-upsell"]');
    if (up && !up.disabled) {
      var variant = parseInt(up.getAttribute('data-variant'), 10);
      if (variant) {
        up.disabled = true;
        YOURAYOUCart.addToCart(variant, 1, {}).then(afterMutation)
          .then(function () { up.disabled = false; })
          .catch(function () { up.disabled = false; showCartError(); });
      }
      return;
    }
  }

  function init() {
    drawer = document.getElementById('cart-drawer');
    scrim = document.getElementById('cart-drawer-scrim');
    if (!drawer || !scrim) return;

    // sortir le tiroir + scrim de tout containing-block (transform/overflow)
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    bigClose = document.getElementById('cd-big-close');
    if (bigClose) document.body.appendChild(bigClose);

    // intercepter l'icône panier du header → ouvre le tiroir
    var toggles = document.querySelectorAll('[data-cart-toggle], a.nav-icon[href$="/cart"], a.nav-icon[href*="/cart?"]');
    toggles.forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    scrim.addEventListener('click', close);
    drawer.addEventListener('click', onDrawerClick);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // ✕ qui suit le curseur sur le voile (visuel ; le clic ferme via le scrim)
    document.addEventListener('mousemove', function (e) {
      if (!bigClose || !bigClose.classList.contains('open')) return;
      bigClose.style.left = e.clientX + 'px';
      bigClose.style.top = e.clientY + 'px';
      var panel = drawer.querySelector('.cd-panel');
      if (panel) {
        var r = panel.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        bigClose.style.opacity = inside ? '0' : '1';
      }
    });

    window.YOURAYOU.openCartDrawer = open;
    window.YOURAYOU.closeCartDrawer = close;
    window.YOURAYOU.renderCartDrawer = renderDrawer;
    window.YOURAYOU.showCartError = showCartError;
  }

  window.YOURAYOU.CartDrawer = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
